function formatMoney(cents) {
    return "₹" + (cents / 100).toLocaleString("en-IN");
}
document.addEventListener("DOMContentLoaded", async () => {

    const STORAGE_KEY = "tkcWishlist";

    const handles = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    const grid = document.getElementById("tkcWishlistGrid");
    const empty = document.getElementById("tkcWishlistEmpty");

    if (!grid) return;

    if (handles.length === 0) {
        empty.removeAttribute("hidden");
        return;
    }

    for (const handle of handles) {

        try {

            const response = await fetch(`/products/${handle}.js`);

            if (!response.ok) continue;

            const product = await response.json();

            grid.insertAdjacentHTML("beforeend", `
                <div class="tkc-card">

                    <a href="${product.url}">
                        <img src="${product.featured_image}" alt="${product.title}">
                    </a>

                    <h3>${product.title}</h3>

                    <div class="tkc-price">
                        ${formatMoney(product.price)}
                    </div>

                    <div class="tkc-actions">

                        <button
                            class="button tkc-add-cart"
                            data-id="${product.variants[0].id}">
                            Add To Cart
                        </button>

                        <button
                            class="button button--secondary tkc-remove"
                            data-handle="${handle}">
                            Remove
                        </button>

                    </div>

                </div>
            `);

        } catch (e) {

            console.log(e);

        }

    }

    document.addEventListener("click", async function(e) {

        if (e.target.classList.contains("tkc-remove")) {

            let items = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

            items = items.filter(item => item !== e.target.dataset.handle);

            localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

            location.reload();

        }

        if (e.target.classList.contains("tkc-add-cart")) {

            await fetch("/cart/add.js", {

                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify({
                    id: e.target.dataset.id,
                    quantity: 1
                })

            });

            window.location = "/cart";

        }

    });

});